export default "__VITE_ASSET__CnTzzWSA__"